import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { DeviceStateIcon } from './state-icons';
export const DeviceStateIndicator = memo(function DeviceStateIndicator(props) {
    const { state, is_alarm = false, ...rest } = props;
    return _jsx(DeviceStateIcon, { ...rest, is_alarm: is_alarm, state: state });
});
